/**
 * Ajustes client-side do menu Conciliação (ordem e itens ocultos).
 * Os itens comentados permanecem nas rotas, mas não aparecem no menu lateral.
 */

const HREF_IMPORTACOES = "/conciliacao/importacoes-extrato";

/** Submenus ocultos temporariamente (comentados no menu). */
const HREFS_OCULTOS = [
  "/conciliacao/codigo-fornecedor",
  "/conciliacao/conciliacao-contabil",
];

const ROTULOS_OCULTOS = [
  "código fornecedor",
  "codigo fornecedor",
  "conciliação contábil",
  "conciliacao contabil",
];

const SUBMENU_IMPORTACOES_PADRAO = {
  idSubMenu: -901,
  submenu: "Importações",
  href: HREF_IMPORTACOES,
};

function normalizarTexto(valor) {
  return String(valor ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
}

function hrefImportacoes(href) {
  const h = String(href ?? "").toLowerCase();
  return h.includes("importacoes-extrato") || h.endsWith("/importacoes");
}

function submenuOculto(sub) {
  const href = String(sub?.href ?? "").toLowerCase();
  if (HREFS_OCULTOS.some((oculto) => href.includes(oculto.replace("/conciliacao/", "")))) {
    return true;
  }
  const rotulo = normalizarTexto(sub?.submenu);
  return ROTULOS_OCULTOS.some((r) => rotulo === normalizarTexto(r));
}

function menuConciliacao(menu) {
  const nome = normalizarTexto(menu?.menu);
  return nome.includes("concili");
}

export function ajustarMenusConciliacao(menus) {
  if (!Array.isArray(menus)) return [];

  return menus.map((menu) => {
    if (!menuConciliacao(menu) || !Array.isArray(menu.submenu)) {
      return menu;
    }

    const visiveis = menu.submenu.filter((sub) => !submenuOculto(sub));
    const importacaoExistente = visiveis.find((sub) => hrefImportacoes(sub.href));
    const demais = visiveis.filter((sub) => !hrefImportacoes(sub.href));
    const importacao = importacaoExistente ?? SUBMENU_IMPORTACOES_PADRAO;

    return {
      ...menu,
      submenu: [importacao, ...demais],
    };
  });
}

export function ajustarMenusPortal(menus) {
  return ajustarMenusConciliacao(menus);
}
